import React from "react";
import { CCard, CCardBody, CBadge, CSpinner, CTooltip } from "@coreui/react";

// "Number of User" BRD — live number of currently logged-in users per
// platform. Sessions are stateless 24h JWTs (no logout tracking), so "live"
// means users with a login inside the active-token window reported by the
// backend. Platforms whose logins never reach this backend are shown as
// "No data" with the reason, never as a fake zero.
const LiveLoggedInUsersCard = ({ data, loading, error, onRefresh }) => {
  const platforms = data?.platforms || [];
  const windowMinutes = data?.window_minutes;
  const windowLabel = windowMinutes
    ? windowMinutes % 1440 === 0
      ? `${windowMinutes / 1440 > 1 ? windowMinutes / 1440 + " days" : "24 hours"}`
      : windowMinutes % 60 === 0
      ? `${windowMinutes / 60} hours`
      : `${windowMinutes} minutes`
    : null;

  return (
    <CCard className="border-light">
      <CCardBody>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h5 style={{ marginBottom: "2px" }}>Live Logged In Users</h5>
            <span className="text-muted" style={{ fontSize: "0.85em" }}>
              Users with an active session
              {windowLabel ? ` (login within the last ${windowLabel})` : ""},
              by platform
            </span>
          </div>
          {onRefresh && (
            <i
              className="bi bi-arrow-clockwise"
              role="button"
              title="Refresh"
              style={{ cursor: "pointer", fontSize: "1.1em" }}
              onClick={onRefresh}
            ></i>
          )}
        </div>
        {loading ? (
          <div className="d-flex justify-content-center py-4">
            <CSpinner color="primary" />
          </div>
        ) : error ? (
          <div className="text-danger py-3">{error}</div>
        ) : (
          <div className="mt-3">
            {platforms.map((p) => (
              <div
                key={p.key}
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "10px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <span>{p.label}</span>
                {p.available ? (
                  <span>
                    <strong style={{ fontSize: "1.2em" }}>
                      {p.total_live}
                    </strong>
                    {p.note && (
                      <CTooltip content={p.note}>
                        <i
                          className="bi bi-info-circle text-muted"
                          style={{ marginLeft: "8px" }}
                        ></i>
                      </CTooltip>
                    )}
                  </span>
                ) : (
                  <CTooltip content={p.reason || "No data source"}>
                    <CBadge
                      color="secondary"
                      style={{ cursor: "help" }}
                    >
                      No data
                    </CBadge>
                  </CTooltip>
                )}
              </div>
            ))}
          </div>
        )}
      </CCardBody>
    </CCard>
  );
};

export default LiveLoggedInUsersCard;
